import "./sw-page.module.css";
import { html, LANGUAGE } from "../../global.ts";
import Strings from "../../../models/Strings.json";

const template = document.createElement("template");
template.innerHTML = html`
    <header class="battambang">
        <label
            for="page-number"
            class="hidden mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >Choose quantity:</label
        >
        <div id="sw-pager" class="relative mt-0 flex items-center max-w-44">
            <button
                id="sw-page-search"
                onclick="heartbank.alertAdmin('page/click/search')"
                title="${Strings.map55[LANGUAGE]}"
                class="absolute top-0 right-1/2 -translate-x-28 flex items-center justify-center opacity-90 text-white bg-blue-500 rounded-full w-10 h-10 hover:bg-blue-500 dark:bg-blue-500 dark:hover:bg-blue-500 focus:ring-4 focus:ring-blue-500 focus:outline-none dark:focus:ring-blue-500">
                <svg
                    class="w-5 h-5"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    fill="currentColor">
                    <path
                        d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376C296.3 401.1 253.9 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
                </svg>
            </button>
            <button
                type="button"
                id="decrement-button"
                onclick="heartbank.alertAdmin('page/click/previous-page')"
                data-input-counter-decrement="page-number"
                class="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-s-lg p-3 h-11 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none">
                <svg
                    class="text-gray-900 dark:text-white"
                    aria-hidden="true"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    height="14"
                    width="12.25"
                    viewBox="0 0 448 512">
                    <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                    <path
                        d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
                </svg>
            </button>
            <input
                inputmode="numeric"
                id="page-number"
                onblur="heartbank.alertAdmin('page/type/', this.value)"
                type="text"
                data-input-counter2
                data-input-counter-min2="0"
                data-input-counter-max2=""
                aria-describedby="helper-text-explanation"
                class="bg-gray-50 border-x-0 border-gray-300 h-11 font-medium text-center text-gray-900 text-lg outline-none focus:ring-0 focus:border-none focus:ring-blue-500 focus:border-blue-500 block w-full pb-6 dark:bg-gray-700 dark:border-gray-600 placeholder-gray-400 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="${Strings.page[LANGUAGE]}"
                value="0" />
            <div
                id="page-total"
                class="absolute bottom-1 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 flex items-center text-xs text-gray-400 space-x-1 rtl:space-x-reverse">
                1 ${Strings.total[LANGUAGE]}
            </div>
            <button
                type="button"
                id="increment-button"
                onclick="heartbank.alertAdmin('page/click/next-page')"
                data-input-counter-increment="page-number"
                class="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-e-lg p-3 h-11 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none">
                <svg
                    class="text-gray-900 dark:text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    fill="currentColor"
                    height="14"
                    width="12.25"
                    viewBox="0 0 448 512">
                    <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                    <path
                        d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                </svg>
            </button>
            <button
                id="sw-page-share"
                onclick="heartbank.alertAdmin('page/click/share')"
                title="${Strings.map58[LANGUAGE]}"
                class="absolute top-0 left-1/2 translate-x-28 flex items-center justify-center opacity-90 text-white bg-green-500 rounded-full w-10 h-10 hover:bg-green-500 dark:bg-green-500 dark:hover:bg-green-500 focus:ring-4 focus:ring-5reen-600 focus:outline-none dark:focus:ring-green-500">
                <svg
                    class="w-5 h-5"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    fill="currentColor">
                    <path
                        d="M307.8 18.4c-12 5-19.8 16.6-19.8 29.6l0 80-112 0c-97.2 0-176 78.8-176 176 0 113.3 81.5 163.9 100.2 174.1 2.5 1.4 5.3 1.9 8.1 1.9 10.9 0 19.7-8.9 19.7-19.7 0-7.5-4.3-14.4-9.8-19.5-9.4-8.8-22.2-26.4-22.2-56.7 0-53 43-96 96-96l96 0 0 80c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-9.2-9.2-22.9-11.9-34.9-6.9z" />
                </svg>
            </button>
        </div>
    </header>
    <main>
        <img
            id="sw-bedok-front"
            alt="Bedok"
            class="hidden cursor-pointer m-0 p-0 object-contain w-full h-full transition-opacity duration-500 opacity-0" />
        <img
            id="sw-bedok-back"
            alt="Bedok"
            class="hidden cursor-pointer m-0 p-0 object-contain w-full h-full transition-opacity duration-500 opacity-0" />
    </main>
    <footer>
        <a
            href="https://youtube.com/@SiliconWat"
            target="_blank"
            class="hidden text-center p-4 text-sm text-gray-500 dark:text-gray-400">
            ${Strings.story[LANGUAGE]}
        </a>
        <div
            id="spinner"
            role="status"
            class="hidden absolute z-[1000] -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
            <svg
                aria-hidden="true"
                class="w-20 h-20 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor" />
                <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill" />
            </svg>
            <span class="sr-only">${Strings.loading[LANGUAGE]}</span>
        </div>
    </footer>
`;

export default template;
